import axios from "axios";
import { env } from "@/shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const uploadClient = axios.create({
  baseURL: env.api.upload,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(uploadClient);

export default uploadClient;
